export default {
  getStatus(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootState.setup.product_id;
      if (!productId) {
        context.commit("setStatus", null);
        resolve(null);
        return;
      }
      window.axios
        .get(`/setup/term/status/${productId}`)
        .then(({ data }) => {
          context.commit("setStatus", data);
          resolve(data);
        })
        .catch(reject);
    });
  },

  accept(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootState.setup.product_id;
      window.axios
        .post(`/setup/term/accept/${productId}`)
        .then(({ data }) => {
          context.commit("markAccepted");
          resolve(data);
        })
        .catch(reject);
    });
  }
};
